$(function() {
   initVariantsSwitcher();
});

function initVariantsSwitcher() {
    var $buttons = $('input[name="options[variants]"]');
    var prices = $('#prices').data('prices');
    if (!$buttons.length || !prices) {
        return;
    }
    try {
        prices = JSON.parse(prices);
    } catch(e) {}
    if (!prices) {
        return;
    }
    $buttons.on('change', function() {
        $('.app-notes--active').removeClass('app-notes--active');
        var variant = this.value;
        $('.app-notes[data-for="' + variant + '"]').addClass('app-notes--active');
        $('.js-price').text(miniShop2.Utils.formatPrice(prices[variant][1]));
        console.log(variant);
    });
    $buttons[0].checked = true;
    $buttons.eq(0).trigger('change');
}